import React from "react";
import { checkedIcon } from "../../../images/svgIcons";
import Button from "../../button";
import "./styles.scss";

const PaymentSuccess = () => (
  <>
    <div className="mx-auto" style={{ width: "fit-content", marginTop: "4vh" }}>
      <div className="d-flex align-items-center justify-content-center success-icon">
        {checkedIcon}
      </div>
    </div>
    <h3 className="text-center mt-5">
      Congratulations! Payment successfully completed
    </h3>
    <div className="d-flex align-items-center justify-content-center mt-5">
      <Button
        onClick={() => {
          window.location.host.includes("localhost")
            ? (window.location.href = "http://localhost:3000/dashboard")
            : window.location.host.includes("37.186.119.181")
            ? (window.location.href = "http://37.186.119.181:3279/dashboard")
            : (window.location.href = "https://dash.hexomatic.com/dashboard");
        }}
      >
        Go to Dashboard
      </Button>
    </div>
  </>
);

export default PaymentSuccess;
